module.exports = __webpack_public_path__ + "static/media/tempelforum.50514f08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/tempelforum.png
// module id = 685
// module chunks = 0